import React from 'react';
import './ContactShareCard.css';

export type ContactShareCardProps = {
  name: string;
  phoneLabel: string;
  timeLabel: string;
  isSent: boolean;
  chatBusy: boolean;
  onChat: (e: React.MouseEvent) => void;
};

function initials(name: string): string {
  const p = name.trim().split(/\s+/).filter(Boolean);
  if (p.length === 0) return '?';
  if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
  return (p[0][0] + p[p.length - 1][0]).toUpperCase();
}

const ContactShareCard: React.FC<ContactShareCardProps> = ({
  name,
  phoneLabel,
  timeLabel,
  isSent,
  chatBusy,
  onChat,
}) => {
  return (
    <div
      className={`contact-share-card ${isSent ? 'contact-share-card--sent' : 'contact-share-card--received'}`}
      onClick={(e) => e.stopPropagation()}
      onPointerDown={(e) => e.stopPropagation()}
      role="group"
      aria-label="Cartão de contato compartilhado"
    >
      <div className="contact-share-card__top">
        <div className="contact-share-card__avatar" aria-hidden>
          {initials(name)}
        </div>
        <div className="contact-share-card__text">
          <div className="contact-share-card__name">{name || 'Contato'}</div>
          {phoneLabel ? <div className="contact-share-card__phone">{phoneLabel}</div> : null}
        </div>
        <span className="contact-share-card__time">{timeLabel}</span>
      </div>
      <div className="contact-share-card__divider" role="separator" />
      <div className="contact-share-card__actions">
        <button
          type="button"
          className="contact-share-card__action contact-share-card__action--primary"
          disabled={chatBusy}
          onClick={onChat}
        >
          {chatBusy ? 'Abrindo…' : 'Conversar'}
        </button>
      </div>
    </div>
  );
};

export default ContactShareCard;
